import classNames from 'classnames';
import { SVGIconProps } from './types/types';

const TickCircle = ({ height = 52, width = 52, className }: SVGIconProps) => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width={height}
    height={width}
    className={classNames(className)}
    viewBox='0 0 52 52'
  >
    <path
      fillRule='evenodd'
      d='M26 48C13.85 48 4 38.15 4 26S13.85 4 26 4s22 9.85 22 22-9.85 22-22 22zm8.47-28.03L23.96 30.479l-6.472-5.548a.75.75 0 0 0-.976 1.138l7 6a.75.75 0 0 0 1.018-.039l11-11a.75.75 0 0 0-1.06-1.06z'
    />
  </svg>
);

export default TickCircle;
